import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromBooking from '../reducers/booking.reducer';
import * as fromUi from '../reducers/ui.reducer';

// UI
export const uiStateSelector = createFeatureSelector<fromUi.UiState>('ui');
export const getUserPhotoUrl = createSelector(uiStateSelector, fromUi.getUserPhotoUrl);
export const getWindowSizeChanged = createSelector(uiStateSelector, fromUi.getWindowSizeChanged);
export const getNavigationState = createSelector(uiStateSelector, fromUi.getNavigationState);
export const getSidebarOpenState = createSelector(uiStateSelector, fromUi.getSidebarOpenState);
export const getSidebarLoadingState = createSelector(
  uiStateSelector,
  fromUi.getSidebarLoadingState
);

export const getModalLoadingState = createSelector(uiStateSelector, fromUi.getModalLoadingState);
export const getUserIdle = createSelector(uiStateSelector, fromUi.getUserIdle);
export const getClientStatus = createSelector(uiStateSelector, fromUi.getClientStatus);
export const getTermsId = createSelector(uiStateSelector, fromUi.getTermsId);

// Booking
export const bookingStateSelector = createFeatureSelector<fromBooking.BookingState>('booking');
export const getBookingState = createSelector(bookingStateSelector, fromBooking.getBookingState);
